<template v-slot:default="">
    <b-sidebar  backdrop id="sidebar-PIG"
         right
        bg-variant="grey" :shadow="true"
        :title="$t('lbl_EMPBE_PIGImgSideBarTitle')"
        @change="onShowSideBar">
        <div class="tab-pane active p-20">
            <div class="ImgWrapper">
                <div v-for="(img, index) in imgUrls" :key="index" class="w-100 h-auto">
                    <div v-if="img.title" class="Title">
                        {{ img.title }}
                    </div>

                    <div v-if="img.type === 'single'" class="w-100">
                        <div>
                            <img :src="img.url" />
                        </div>
                    </div>
                    <div v-if="img.type === 'list'" class="ImgGrid" :style="{'grid-template-columns': `repeat(${img.repeatColumn}, 1fr)`}">
                        <div v-for="url, index in img.list" :key="index">
                            <img :src="url" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-sidebar>
</template>

<script>
export default{
    props: ['imgs'],

    computed: {
        imgUrls() {
            return this.imgs.map((i) => {
                return {
                    ...i,
                    repeatColumn: i.type === "single" ? 1 : i.list.length,
                };
            });
        }
    },

    methods: {
        onShowSideBar(visible) {
            // Force background to be not scrollable
            if (visible) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflowY = "scroll";
            }
        }
    }
}
</script>

<style lang="scss">
#sidebar-PIG {
    > .b-sidebar-header {
        padding: 1rem 2rem;
        background-color: #fff;
        border-bottom: 1px solid #ecf3fa;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;

        button.close {
            margin-right: 24px;
        }
    }

    .tab-pane {
        background-color: #fff;

        .ImgWrapper {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 24px;

            div.ImgGrid {
                display: grid;
                width: 100%;
                gap: 24px;
            }

            img {
                width: 100%;
            }

            .Title {
                    color: rgba(0, 0, 0, 0.80);
                    font-size: 18px;
                    font-weight: 700;
                    line-height: 23.40px;
                    margin-bottom: 0.5rem;
            }
        }
    }
}
</style>